$(() => {
    //事業所管理以外はreturn
    if (!$('#interviewer-management').length) {
        return;
    }

    let dualListContainer = $('select[name="students_list[]"]').bootstrapDualListbox({
        'filterPlaceHolder': '絞り込み',
        'infoText': '{0}件',
        'infoTextFiltered': '{0} から {1}<span class="label label-warning">を絞り込み</span> ',
        'filterTextClear': '全て表示',
        'infoTextEmpty': '0件',
        'preserveSelectionOnMove': '全',
        'iconsPrefix': 'fas',
        'iconMove': 'fa-angle-double-right',
        'iconRemove': 'fa-angle-double-left',
    });

    $('.moveall i').removeClass().addClass('fa fa-angle-right');
    $('.removeall i').removeClass().addClass('fa fa-angle-left');

    $('.select2').select2({
        ajax: {
            url: '/manager/corporate/get_list',
            dataType: 'json',
            delay: 250
        },
        language: "ja",
        escapeMarkup: function (markup) {
            return markup;
        }
    });

    $('.student_detail').on('click', function() {
        let param = {};
        param.student_id = $(this).data('id');
        axios.post('/manager/interview/student_detail', param)
            .then((response) => {
                let student = response.data.results;
                $('#student_photo').attr('src', student.student_photo);
                $('#student_id').text(student.student_id);
                $('#student_name').text(student.student_name);
                if (student.student_resume.length) {
                    $('#student_resume a').attr('href', student.student_resume);
                    $('#student_resume a').removeClass('disabled');
                } else {
                    $('#student_resume a').attr('href','');
                    $('#student_resume a').addClass('disabled');
                }
                if (student.student_profile.length) {
                    $('#student_profile a').attr('href', student.student_profile);
                    $('#student_profile a').removeClass('disabled');
                } else {
                    $('#student_profile a').attr('href','');
                    $('#student_profile a').addClass('disabled');
                }
                if (student.exam_result.length) {
                    $('#exam_result a').attr('href', student.exam_result);
                    $('#exam_result a').removeClass('disabled');
                } else {
                    $('#exam_result a').attr('href','');
                    $('#exam_result a').addClass('disabled');
                }
                if (student.japaneses_exam_result.length) {
                    $('#japaneses_exam_result a').attr('href', student.japaneses_exam_result);
                } else {
                    $('#japaneses_exam_result a').attr('href','');
                    $('#japaneses_exam_result a').addClass('disabled');
                }
                if (student.jf_japaneses_exam_result.length) {
                    $('#jf_japaneses_exam_result a').attr('href', student.jf_japaneses_exam_result);
                } else {
                    $('#jf_japaneses_exam_result a').attr('href','');
                    $('#jf_japaneses_exam_result a').addClass('disabled');
                }
                $('#staticBackdrop').modal('show');
            }).catch(
                err => {
                    const regex = /401|403/;
                    if (err.message.match(regex)) {
                        alert('セッションが切れたため、ログイン画面へ戻ります。');
                        document.location.href = '/login';
                    } else {
                        alert(err);
                    }
                    return;
                }
            );
    })

    $('button[data-dismiss="modal"]').on('click', function() {
        $('#staticBackdrop').modal('hide');
    });

    $('.status_selection').on('change', function() {
        let param = {};
        param.student_id = $(this).data('student_id');
        param.corporate_id = $(this).data('corporate_id');
        param.status = $(this).val();
        let role = $(this).data('role');
        axios.post('/' + role + '/interview/status', param)
        .then((response) => {
            if (!response.data.status) {
                alert(response.data.message);
            }
        }).catch(
            err => {
                const regex = /401|403/;
                if (err.message.match(regex)) {
                    alert('セッションが切れたため、ログイン画面へ戻ります。');
                    document.location.href = '/login';
                } else {
                    alert(err);
                }
                return;
            }
        );
    })
});
